import createIcon from '../../createIcon';

/**
 * @component @name Festival
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNi4yVjQuNUgxNkwxNSAzLjAxTDE2IDEuNUgxMVY2LjJMMiAxMi41VjIyLjVIOVYxNy41TDEyLjAzIDE1LjVMMTUgMTcuNVYyMi41SDIyVjEyLjVMMTMgNi4yWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Festival = createIcon('Festival', [
  [
    'path',
    {
      d: 'M13 6.2V4.5H16L15 3.01L16 1.5H11V6.2L2 12.5V22.5H9V17.5L12.03 15.5L15 17.5V22.5H22V12.5L13 6.2Z',
      key: 'pgb8l6',
    },
  ],
]);

export default Festival;
